
const globalNavMenu = document.querySelector('.header-nav__list.-menu');

globalNavMenu.addEventListener('click', function (e) {
  if (document.body.classList.contains('menu-open')) {
    document.body.classList.remove('menu-open');
  } else {
    document.body.classList.add('menu-open');
  }
  return false;
});

const globalCloseNav = document.querySelector('.close-nav');

globalCloseNav.addEventListener('click', function (e) {
  if (document.body.classList.contains('menu-open')) {
    document.body.classList.remove('menu-open');
  } else {
    document.body.classList.add('menu-open');
  }
  return false;
});

const globalCorporateNav = document.querySelector('.header-nav__lists.-corporate');

globalCorporateNav.addEventListener('mouseover', function (e) {
  this.classList.add('menu-open');
});
globalCorporateNav.addEventListener('mouseout', function (e) {
  this.classList.remove('menu-open');
});
